import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useHistory } from 'react-router';

import CONSTANTS from '../constants';
import utils from '../utils';
import UrlDrivenAppDisplay from '../components/UrlDrivenAppDisplay';
import ListSkeletonLoader from '../components/Layout/ListSkeletonLoader';
import NavUtils from '../NavUtils';



function DemoApp({tenant}) {
    const history = useHistory();
    let hasAccess = NavUtils.hasAppAccess(tenant, CONSTANTS.APPS_BY_APPTYPE.DEMO_APP);
  
    if(!hasAccess) {
        history.push('/');
    }
      
    let [ contentModel, setContentModel ] = useState();
    let [ navDescr, setNavDescr ] = useState([]);
    let [ loading, setLoading ] = useState(true);
    const { user, getAccessTokenSilently } = useAuth0();


    let tenantSlug = tenant.tenant.fields.tenantslug;
  
    let tenID = utils.getForceTenantValue();
  
    if (!tenID) {
      //if no currently set forceTenantValue, get the id from the agility record, and set it in localstorage
      tenID = tenant.tenant.fields.aDGroupID || null;
      utils.setForceTenantValue(tenID);
    }

    const getContentModel = async (token) => {
        let extraParams = 'force_id=' + tenant.tenant.fields.aDGroupID;
        let jsonresponse = await utils.getTenantContent(token, CONSTANTS.APPS_BY_APPTYPE.DEMO_APP, tenantSlug, tenant.ourUserID, extraParams);

        setContentModel(jsonresponse.content);
    }

     useEffect( () => {
        try{
            (async () => {
                let accToken = await utils.getAccessToken(getAccessTokenSilently, user);
                let apiKey = await utils.getAPIKey(accToken);
                let response = await utils.getAppNavItems('get_app_blueprint_b2c', 'demo_app', accToken.accessToken, apiKey, false); 
                await getContentModel(accToken);
                setNavDescr(response);
                setLoading(false)
            })()
        } catch(error) {
            console.log(error);
            setLoading(false);
        }
    // eslint-disable-next-line
    },[]);

    
    return (
        !loading ?
            contentModel ?
            <div className='url-driven-app'>
                <UrlDrivenAppDisplay 
                tenant={tenant}
                className={CONSTANTS.APPS_BY_APPTYPE.DEMO_APP}
                content={contentModel[0]}
                navs={navDescr}
                appType={'DEMO_APP'}
                defaultPage="tab_one" 
                displayFieldName={""} 
                hasSubItems={null} />
            </div>
            : <div>Content Model Not Found</div>
        : <ListSkeletonLoader preview={false} />
    )
}

export default DemoApp